import Env from "./env";
import { Logger } from "./logger";

export  const RedirectToConnectPortal = () => {
    const CONNECT_PORTAL_URL = Env.ConnectPortalUrls[Env.getEnvName()];
    const LOGIN_URL = CONNECT_PORTAL_URL + "user/account/jwt-session?target=" + encodeURI(window.location.href);
    Logger('Redirecting... -> ', LOGIN_URL);
    window.location.href = LOGIN_URL;
};

export  const RedirectToOnboardingPage = () => {
    const CONNECT_PORTAL_URL = Env.ConnectPortalUrls[Env.getEnvName()];
    const agreementsUrl = CONNECT_PORTAL_URL + "account/onboarding";
    Logger('Redirecting... -> ', agreementsUrl);
    window.location.href = agreementsUrl;
};


// Redirect to troubleshooting guide
export const RedirectToTrobubleShootingGuide = () => {
    const troubleShootingUrl = 'https://github.com/redhat-openshift-ecosystem/certification-releases/blob/main/containers/troubleshooting.md';
    Logger('Redirecting... -> ', troubleShootingUrl);
    window.open(troubleShootingUrl);
}
